<template>
    <!--********** FINESTRA MODALE **********-->
    <div class="modal is-active">
        <div class="modal-background"></div>
        <div class="modal-content">
            <article class="message">
                <div class="message-body" v-if="messaggioAttivo">
                    <div class="buttons is-centered">
                        <button class="button is-primary" :class="{'is-outlined': tipoSconto != 'iva'}" @click="bModificaTipoSconto('iva')">IVA al 22%</button>
                        <button class="button is-primary" :class="{'is-outlined': tipoSconto != 'viessmann'}" @click="bModificaTipoSconto('viessmann')">Sconti Viessmann</button>
                        <button class="button is-primary" :class="{'is-outlined': tipoSconto != 'generico'}" @click="bModificaTipoSconto('generico')">Sconti generici</button>
                    </div>
                    <p class="has-text-centered" v-if="tipoSconto=='iva'"><br>Proseguendo scorporerai l'iva al 22% dal costo</p>
                    <p class="has-text-centered" v-if="tipoSconto=='iva'"><br>{{props.confMessaggioModale.numeroDaModificare
                            .toLocaleString("it-IT", {notation: "standard", minimumFractionDigits: 2, maximumFractionDigits: 2})
                        + " - IVA al 22%"
                        + ' = ' + (props.confMessaggioModale.numeroDaModificare/(1+aliquota1/100)/(1+aliquota2/100)/(1+aliquota3/100))
                            .toLocaleString("it-IT", {notation: "standard", minimumFractionDigits: 2, maximumFractionDigits: 2}) }} </p>
                    <p class="has-text-centered" v-if="tipoSconto=='iva'"><br></p>
                    <p class="has-text-centered" v-if="tipoSconto=='viessmann'||tipoSconto=='generico'"><br>Proseguendo applicherai i seguenti sconti all'importo</p>
                    <p class="has-text-centered" v-if="tipoSconto=='viessmann'||tipoSconto=='generico'"><br></p>
                    <div class="field" v-if="tipoSconto=='viessmann'||tipoSconto=='generico'">
                        <div class="control">
                            <div class="columns">
                                <div class="column"> <input class="input" style="text-align: center;" type="text" v-model="aliquota1"></div>
                                <div class="column"> <input class="input" style="text-align: center;" type="text" v-model="aliquota2"></div>
                                <div class="column"> <input class="input" style="text-align: center;" type="text" v-model="aliquota3"></div>
                            </div>
                        </div>
                    </div>
                    <p class="has-text-centered" v-if="tipoSconto=='viessmann'||tipoSconto=='generico'"><br>{{ props.confMessaggioModale.numeroDaModificare
                            .toLocaleString("it-IT", {notation: "standard", minimumFractionDigits: 2, maximumFractionDigits: 2})
                        + (aliquota1<0?' + ':' - ') + Math.abs(aliquota1) + "% "
                        + (aliquota2<0?' + ':' - ') + Math.abs(aliquota2) + "% "
                        + (aliquota3<0?' + ':' - ') + Math.abs(aliquota3) + "% "
                        + ' = ' + (props.confMessaggioModale.numeroDaModificare*(1-aliquota1/100)*(1-aliquota2/100)*(1-aliquota3/100))
                            .toLocaleString("it-IT", {notation: "standard", minimumFractionDigits: 2, maximumFractionDigits: 2}) }} </p>
                    <p class="has-text-centered" v-if="tipoSconto=='viessmann'||tipoSconto=='generico'"><br></p>
                    <p v-if="props.confMessaggioModale.download"><br></p>
                    <p><br></p>
                    <div class="buttons is-centered">
                        <button class="button" @click="bSeleziona('annulla')">Annulla</button>
                        <button class="button is-primary" @click="bSeleziona('applicaSconto')" v-if="tipoSconto=='iva'">Scorpora l'IVA al 22%</button>
                        <button class="button is-primary" @click="bSeleziona('applicaSconto')" v-if="tipoSconto=='viessmann'||tipoSconto=='generico'">Applica gli sconti</button>
                    </div>
                </div>
            </article>
        </div>
    </div>
</template>

<script setup>
    import { defineProps, defineEmits, ref, nextTick } from "vue";

    // PROPRIETA' ED EVENTI DEL COMPONENTE
    const props = defineProps({
        // Deve ricevere un oggetto del tipo:
        // { numeroDaModificare: 1200 }
        confMessaggioModale: {
            type: Object,
            default: () => {return null}
        }
    });
    const emit = defineEmits(['selezionato']);

    // VARIABILI DEL COMPONENTE
    const aliquota1 = ref(22);
    const aliquota2 = ref(0);
    const aliquota3 = ref(0);
    const tipoSconto = ref('iva');      // 'iva' - 'viessmann' - 'generico'
    const messaggioAttivo = ref(true);      // Serve a spegnere il messaggio per imporre il reset di tutta l'interfaccia

    

    // SETUP DEL COMPONENTE

    // FUNZIONI DEL COMPONENTE
    function bSeleziona(comando) {
        if (tipoSconto.value == 'iva') 
            emit('selezionato', comando, (props.confMessaggioModale.numeroDaModificare/(1+aliquota1.value/100)/(1+aliquota2.value/100)/(1+aliquota3.value/100)).toFixed(2));
        else
            emit('selezionato', comando, (props.confMessaggioModale.numeroDaModificare*(1-aliquota1.value/100)*(1-aliquota2.value/100)*(1-aliquota3.value/100)).toFixed(2));
    }

    function bModificaTipoSconto(tipo) {
        if (tipoSconto.value != tipo) {
            tipoSconto.value = tipo;
            switch (tipo) {
                case 'iva':
                    aliquota1.value = 22;
                    aliquota2.value = 0;
                    aliquota3.value = 0;
                    break;
                case 'viessmann':
                    aliquota1.value = 43;
                    aliquota2.value = 10;
                    aliquota3.value = -5;
                    break;
                case 'generico':
                    aliquota1.value = 10;
                    aliquota2.value = 0;
                    aliquota3.value = 0;
            }
            resetMessaggio();
        }
    }

    async function resetMessaggio() {
        // Resetta l'interfaccia del form per permettere l'aggiornamento
        messaggioAttivo.value = false;
        await nextTick();
        messaggioAttivo.value = true;
    }

</script>